// extracted by mini-css-extract-plugin
export var background = "Header-module--background--927e4";
export var backgroundBlue = "Header-module--backgroundBlue--42a7f";
export var backgroundIntro = "Header-module--backgroundIntro--cc954";
export var backgroundLight = "Header-module--backgroundLight--a07ef";
export var backgroundMaroon = "Header-module--backgroundMaroon--c2a1a";
export var backgroundOrange = "Header-module--backgroundOrange--176e6";
export var backgroundPink = "Header-module--backgroundPink--d6006";
export var backgroundPurple = "Header-module--backgroundPurple--eb4fb";
export var backgroundTeal = "Header-module--backgroundTeal--df9f8";
export var fixedWrapper = "Header-module--fixedWrapper--05b5e";
export var header2025 = "Header-module--header2025--37355";
export var header2025Center = "Header-module--header2025Center--475ae";
export var header2025ChapterSlug = "Header-module--header2025ChapterSlug--e3cc8";
export var header2025Container = "Header-module--header2025Container--5e6c7";
export var header2025Hamburger = "Header-module--header2025Hamburger--45243";
export var header2025Index = "Header-module--header2025Index--47905";
export var header2025LangSwitcher = "Header-module--header2025LangSwitcher--b5209";
export var header2025Logo = "Header-module--header2025Logo--d0ed7";
export var header2025Month = "Header-module--header2025Month--29b2c";
export var header2025Right = "Header-module--header2025Right--5b87e";
export var header2025Theme = "Header-module--header2025Theme--717b3";
export var header2025Title = "Header-module--header2025Title--2576b";
export var header2025YearSelect = "Header-module--header2025YearSelect--33327";
export var heading = "Header-module--heading--46714";
export var languageToggleWrapper = "Header-module--languageToggleWrapper--d557c";
export var logo = "Header-module--logo--9b96a";
export var logoAlign = "Header-module--logoAlign--fc00d";
export var logoContainer = "Header-module--logoContainer--457bd";
export var navbar = "Header-module--navbar--15b8c";
export var selectBg = "Header-module--selectBg--002cd";
export var toggleThemeWrapper = "Header-module--toggleThemeWrapper--57019";
export var wrapper = "Header-module--wrapper--bce18";